import React, { useState, useEffect } from 'react';
import { apis, hooks, models } from "@vote4dance/judging-sdk";
import { Button, Dropdown, notification, Space } from 'antd';
import { _T } from "../../../../../base-react/src/Localization";
import { DeleteOutlined, DownOutlined, PlusOutlined, UserAddOutlined } from '@ant-design/icons';
import { TeamEdit } from '../../teams/components/TeamEdit';
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var ClassRoundSource = models.rounds.ClassRoundSource;
import { RoundTable } from '../../../../components/RoundTable';
import { groupClassRoundsIntoChildren } from '../utilities';
import { RoundType } from '@vote4dance/judging-schema';
import { ButtonConfirm } from '../../../../../base-react/components/ButtonConfirm';
import { useFederationSettings } from '../../../../../base-react/hooks/Federation';
import { Link } from 'react-router-dom';
import { ClassRoundGuide } from './ClassRoundGuide';
import { ExternalAPI } from '../../../../components/ExternalAPI';
export const ClassRoundsTable = (props) => {
    const { event_id, competition_id, classItem, disabled } = props;
    const { usingPointSummary } = useFederationSettings(competition_id);
    const [filteredRounds, setFilteredRounds] = useState([]);
    const [rounds, loading] = Stream(ClassRoundSource(classItem.class_id));
    const [showRegisterDancer, setShowRegisterDancer] = useState(false);
    useEffect(() => {
        if (rounds) {
            setFilteredRounds(groupClassRoundsIntoChildren(rounds));
        }
    }, [rounds]);
    const onDeleteRound = async (selection, done) => {
        // Create a set of parent round IDs in the selection
        const parentRoundIds = new Set(selection.map(round => parseInt(round.round_id)));
        // Filter out child rounds whose parent is already in the selection
        const filteredSelection = selection.filter(round => !parentRoundIds.has(parseInt(round.round_parent_id || "0")));
        for (let each of filteredSelection) {
            await Api.destroy(`${ClassRoundSource(classItem.class_id).url}/${each.round_id}`)
                .then(() => {
                notification.success({
                    message: _T('common.delete.success', { name: each.round_label }),
                });
            })
                .catch((err) => {
                var _a;
                notification.error({
                    message: ((_a = err.response) === null || _a === void 0 ? void 0 : _a.message) ? _T(err.response.message) : err.message,
                });
            });
        }
        done();
    };
    const registerDancer = () => {
        setShowRegisterDancer(true);
    };
    const footer = (selection) => {
        const otherRounditems = [
            {
                label: React.createElement(Link, { to: `../classes/${classItem.class_id}/points` }, _T('round.points')),
                key: RoundType.Points,
                disabled: filteredRounds.length === 0
            },
        ];
        const otherRoundMenuProps = {
            items: otherRounditems
        };
        return (React.createElement(Space, { wrap: true },
            React.createElement(ClassRoundGuide, { competition_id: competition_id, classItem: classItem, rounds: rounds, disabled: disabled }),
            React.createElement(Link, { to: `../classes/${classItem.class_id}/new` },
                React.createElement(Button, { icon: React.createElement(PlusOutlined, null), disabled: disabled || selection.length > 0 }, _T('common.add', { name: _T('round.title').toLowerCase() }))),
            selection.length > 0 &&
                React.createElement(ButtonConfirm, { title: _T('common.delete.title', { name: _T('round.title').toLowerCase() }), description: _T('common.delete.content', { name: _T('round.title').toLowerCase() }), onConfirm: (done) => onDeleteRound(selection, done), buttonProps: {
                        danger: true,
                        icon: React.createElement(DeleteOutlined, null),
                        disabled: disabled
                    } }),
            React.createElement(Button, { icon: React.createElement(UserAddOutlined, null), disabled: disabled, onClick: () => registerDancer() }, _T('team.register')),
            usingPointSummary &&
                React.createElement(Dropdown, { menu: otherRoundMenuProps, disabled: disabled || selection.length > 0 },
                    React.createElement(Button, { icon: React.createElement(PlusOutlined, null) },
                        _T('common.add', { name: _T('common.other').toLowerCase() }),
                        React.createElement(DownOutlined, null))),
            React.createElement(ExternalAPI, { competition_id: competition_id, classItem: classItem, mode: 'sync', disabled: disabled })));
    };
    return (React.createElement("div", { style: { marginTop: 8 } },
        React.createElement(RoundTable, { event_id: event_id, data: filteredRounds, loading: loading, mode: "class", footer: footer }),
        React.createElement(TeamEdit, { competition_id: competition_id, classItem: classItem, visible: showRegisterDancer, onClose: () => setShowRegisterDancer(false), disabled: disabled })));
};
